import React, { Component } from "react";
import { postProfileDataSaveAction } from 'store/Profiler'
import { connect } from "react-redux";
  

class Profiler extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isTabOpenNo: 1,
       Perseverance1: "",
      Perseverance2: "",
      Closure1: "",
      Closure2: "",
      Closure3: "",
      Resilience1: "",
      Resilience2: "",
      Resilience3: "",
      Personalorganisation1: "",
      Personalorganisation2: "",
      Personalorganisation3: "",
      Sociallyconfident1: "",
      Sociallyconfident2: "" ,
      Passion1: "" ,
      Passion2: "" ,
      Problemsolving1: "" ,
      Problemsolving2: "" ,
      Affiliation1: "" ,
      Affiliation2: "" ,
      Affiliation3: "" ,
      Affiliation4: "" ,
      ServiceRecovery1: "" ,
      ServiceRecovery2: "" ,
    };
  }

  //ErrorMessage: "Invalid length for a Base-64 char array or string
    isKycCompletedCheck() {
    let arr1 = [
      this.state.Perseverance1 == "" ? false : true,
      this.state.Perseverance2 == "" ? false : true,
      this.state.Closure1 == "" ? false : true,
      this.state.Closure2 == "" ? false : true,
      this.state.Closure3 == "" ? false : true,
      this.state.Resilience1 == "" ? false : true,
      this.state.Resilience2 == "" ? false : true,
      this.state.Resilience3 == "" ? false : true,
      this.state.Personalorganisation1 == "" ? false : true,
      this.state.Personalorganisation2 == "" ? false : true,
      this.state.Personalorganisation3 == "" ? false : true,
      this.state.Sociallyconfident1 == "" ? false : true,
      this.state.Sociallyconfident2 == "" ? false : true,
      this.state.Passion1 == "" ? false : true,
      this.state.Passion2 == "" ? false : true,
      this.state.Problemsolving1 == "" ? false : true,
      this.state.Problemsolving2 == "" ? false : true,
      this.state.Affiliation1 == "" ? false : true,
      this.state.Affiliation2 == "" ? false : true,
      this.state.Affiliation3 == "" ? false : true,
      this.state.Affiliation4 == "" ? false : true,
      this.state.ServiceRecovery1 == "" ? false : true,
      this.state.ServiceRecovery2 == "" ? false : true,
    ];
    let checker = (arr) => arr.every(Boolean);
    return checker(arr1);
  }

   saveProfiler(e) {
     e.preventDefault()
    
    
     let data = {

      CandidateName: this.props.Auth.USER_DETAILS_HC.Data[0].CandidateName,
      ProfileData: [
        {
          Categorytitle: "Perseverance",
          CategoryArray: [
            {
              SubCatTitle: "Makes repeated attempts",
              Answer: this.state.Perseverance1,
            },
            {
              SubCatTitle: "Tries alternate methods",
              Answer: this.state.Perseverance2,
            },
          ],
        },
        {
          Categorytitle: "Closure",
          CategoryArray: [
            {
              SubCatTitle: "Focused on task completion",
              Answer: this.state.Closure1,
            },
            {
              SubCatTitle:
                "Follows up with relevant people till task is complete",
              Answer: this.state.Closure2,
            },
            {
              SubCatTitle: "Keeps commitments",
              Answer: this.state.Closure3,
            },
          ],
        },
        {
          Categorytitle: "Resilience",
          CategoryArray: [
            {
              SubCatTitle: "Emotionally controlled",
              Answer: this.state.Resilience1,
            },
            {
              SubCatTitle: "Bounces back from failures and setbacks",
              Answer: this.state.Resilience2,
            },
            {
              SubCatTitle:
                "Does not avoid engagements with difficult and irate people",
              Answer: this.state.Resilience3,
            },
          ],
        },
        {
          Categorytitle: "Personal organisation",
          CategoryArray: [
            {
              SubCatTitle: "Adheres to the defined process",
              Answer: this.state.Personalorganisation1,
            },
            {
              SubCatTitle: "Has orientation to schedule",
              Answer: this.state.Personalorganisation2,
            },
            {
              SubCatTitle: "Has an orientation to detect mistakes and errors",
              Answer: this.state.Personalorganisation3,
            },
          ],
        },
        {
          Categorytitle: "Socially confident",
          CategoryArray: [
            {
              SubCatTitle: "Displays comfort in interacting with new contacts",
              Answer: this.state.Sociallyconfident1,
            },
            {
              SubCatTitle: "Starts conversation with new people easily",
              Answer: this.state.Sociallyconfident2,
            },
          ],
        },
        {
          Categorytitle: "Passion",
          CategoryArray: [
            {
              SubCatTitle: "Takes initiative",
              Answer: this.state.Passion1,
            },
            {
              SubCatTitle: "Does not avoid targets",
              Answer: this.state.Passion2,
            },
          ],
        },
        {
          Categorytitle: "Problem solving",
          CategoryArray: [
            {
              SubCatTitle: "Identifies right people for resolving the problem",
              Answer: this.state.Problemsolving1,
            },
            {
              SubCatTitle: "Does not hesitate to ask for assistance/help",
              Answer: this.state.Problemsolving2,
            },
          ],
        },
        {
          Categorytitle: "Affiliation",
          CategoryArray: [
            {
              SubCatTitle: "Seeks information",
              Answer: this.state.Affiliation1,
            },
            {
              SubCatTitle: "Offers information",
              Answer: this.state.Affiliation2,
            },
            {
              SubCatTitle: "Does not display haste to complete the engagement",
              Answer: this.state.Affiliation3,
            },
            {
              SubCatTitle: "Offers help to others",
              Answer: this.state.Affiliation4,
            },
          ],
        },
        {
          Categorytitle: "Service Recovery",
          CategoryArray: [
            {
              SubCatTitle: "Understands and acknowledges feelings and emotions",
              Answer: this.state.ServiceRecovery1,
            },
            {
              SubCatTitle: "Understands needs of others",
              Answer: this.state.ServiceRecovery2,
            },
          ],
        },
      ],
     };
      let payload = {
       CandidateNo: this.props.Auth.USER_DETAILS_HC.Data[0].CandidateNo,
       data:data
     }
     this.props.postProfileDataSaveAction(payload)
   
  }

 
  render() {
    return (
      <card className="rounded-12px drop-shadow20 bg-white block lg:p-8 md:p-8 p-5  lg:mt-12 md:mt-12 sm-shadow-none">
        <div className="lg:px-12 md:px-12  pb-8">
          <div>
            {" "}
            <h1 className="text262626 fsize24 font-semibold sm-fsize16">
              Instructions
            </h1>
            <ul className="mt-4">
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                Personality profiling helps us know more about your working
                style and preferred way of behaving in a work place.
              </li>
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                This is not a test. Hence, there is no right or wrong answer in
                this section. Neither is there any cut-off.{" "}
              </li>{" "}
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                Your responses help us know more about your personality
                preferences.
              </li>
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                There are 23 questions in total.{" "}
              </li>
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                All the questions are to be answered for you to complete the
                profiling exercise.
              </li>{" "}
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                Each question has 3 alternative choices. You are requested to
                select one of the three choices, which you can best relate to.
              </li>
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                {" "}
                The other two choices have to be left blank.
              </li>{" "}
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                We would advise you to go with your first instincts and respond
                spontaneously.
              </li>{" "}
              <li className="list-decimal  sm-fsize14	fsize18 text-black line-h30   lg:ml-0 md:ml-0 ml-4">
                It takes about 15 minutes to complete the section. There is no
                time limit. You can do it at ease.
              </li>
            </ul>
          </div>{" "}
          <div class="divider-card-b opacity-30 mt-10 mb-8"></div>
          <div className="">
            <h1 className="text262626 fsize24 font-semibold sm-fsize16 mb-4">
              Questions
            </h1>
            <div className="mb-6">
              <ul>
                <li className="text-black list-decimal fsize16 sm-fsize14 line-h30 lg:ml-0 md:ml-0 ml-4">
                  You have been trying to contact your college senior for the
                  past 4 days for a project. He has worked on that project
                  earlier.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-1"
                    class="radio-custom"
                    name="radio-groupq1"
                    type="radio"
                    defaultValue="High"
                    onChange={e => {
                      this.setState({
                                      Perseverance1:
                                         e.target.value
                      })    
                    }      
                    }
                  />
                  <label
                    for="radio-1"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will meet him in person and request for his time.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-2"
                    class="radio-custom"
                    name="radio-groupq1"
                    type="radio"
                    defaultValue="Medium"
                    onChange={(e => {  
                      this.setState({
                                      Perseverance1:
                                                                e.target.value,
                                                            })}) 
                         }
                  />
                  <label
                    for="radio-2"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will wait for my senior to call back.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-3"
                    class="radio-custom"
                    name="radio-groupq1"
                    type="radio"
                    defaultValue="Low"
                    onChange={(e => {
                      this.setState({
                                      Perseverance1:
                                                                e.target.value,
                                                            })})
                         }
                  />
                  <label
                    for="radio-3"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will reach him through a common friend.
                  </label>
                </div>
              </div>
            </div>

            <div className="mb-6">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                  The Head of the department of your college has rejected your
                  project report for the third time.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-4"
                    class="radio-custom"
                    name="radio-groupq2"
                    type="radio"
                    defaultValue="High"
                    onChange={(e => {
                      this.setState({
                                      Perseverance2:e.target.value
                                                            })})
                     
                         }
                  />
                  <label
                    for="radio-4"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will try to make up for the poor marks in the project
                    through higher marks in the written exam.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-5"
                    class="radio-custom"
                    name="radio-groupq2"
                    type="radio"
                      defaultValue="Medium"
                    onChange={(e => {
          
                      this.setState({
                                      Perseverance2:
                                                                e.target.value
                                                            })})
                     
                         }
                  />
                  <label
                    for="radio-5"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will meet him once again to explain my project.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-6"
                    class="radio-custom"
                    name="radio-groupq2"
                    type="radio"
                      defaultValue="Low"
                    onChange={(e => {
                      this.setState({
                                      Perseverance2:
                                                                e.target.value,
                                                            })})
                     
                         }
                  />
                  <label
                    for="radio-6"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will take another teacher’s help to improve the project
                    report.
                  </label>
                </div>
              </div>
            </div>

            <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                  You are in your college working on an assignment which is due
                  today. It has started to rain and there is a bus/autorickshaw
                  strike.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-7"
                    class="radio-custom"
                    name="radio-groupq3"
                    type="radio"
                     defaultValue="High"
                       onClick={(e) => {
                    
                                                            this.setState({
                                                              Closure1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-7"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will finish my assignment and then go home.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-8"
                    class="radio-custom"
                    name="radio-groupq3"
                    type="radio"
                      defaultValue="Medium"
                    onClick={(e) => {
                       
                     this.setState({
                       Closure1: e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-8"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will leave with my friends and come early tomorrow to
                    finish the assignment.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-9"
                    class="radio-custom"
                    name="radio-groupq3"
                    type="radio"
                      defaultValue="Low"
                       onClick={(e) => {
                  
                  
                                                            this.setState({
                                                              Closure1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-9"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will call up my teacher and seek an extension on the
                    timeline.
                  </label>
                </div>
              </div>
            </div>

            <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                  The ceiling fan in your college classroom has not been working
                  properly since 1 month. You have made a complaint with the
                  college authorities.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-10"
                    class="radio-custom"
                    name="radio-groupq4"
                    type="radio"
                    defaultValue="High"
                    onClick={(e) => {
                                                            this.setState({
                                                              Closure2:
                                                                e.target.value,
                                                            })
                    }
                    }

                  />
                  <label
                    for="radio-10"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will follow up with the authorities on a regular basis
                    till they change the fan.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-11"
                    class="radio-custom"
                    name="radio-groupq4"
                    type="radio"
                      defaultValue="Medium"
                    onClick={(e) => {
                      
                                                            this.setState({
                                                              Closure2:
                                                                e.target.value,
                                                            })
                    }
                    }
                    
                  />
                  <label
                    for="radio-11"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I have made the complaint. I am sure they will take care of
                    it.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-12"
                    class="radio-custom"
                    name="radio-groupq4"
                    type="radio"
                      defaultValue="Low"
                    onClick={(e) => {
                                                            this.setState({
                                                              Closure2:
                                                                e.target.value,
                                                            })
                    }
                    }
                  />
                  <label
                    for="radio-12"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I have made the complaint. I will send a reminder if they
                    don’t take action on time.
                  </label>
                </div>
              </div>
            </div>
            
            <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                 You have commited to your
                                                  landlord that you would pay
                                                  the rent on 5th of every
                                                  month. It is 5th today and you
                                                  are out of town.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-67"
                    class="radio-custom"
                    name="radio-groupq5"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) =>
                    {
                                                            this.setState({
                                                              Closure3:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-67"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                     I will pay the rent in  advance
                  </label>
                </div>
                <div>
                  <input
                    id="radio-68"
                    class="radio-custom"
                    name="radio-groupq5"
                    type="radio"
                      defaultValue="Medium"
                     onClick={(e) =>
                    {
                                                            this.setState({
                                                              Closure3:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-68"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    I will call my landlord and seek his permission to pay the rent upon my return.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-69"
                    class="radio-custom"
                    name="radio-groupq5"
                    type="radio"
                          defaultValue="Low"
                     onClick={(e) =>
                    {
                                                            this.setState({
                                                              Closure3:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-69"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                        I will ask my brother   to pay the rent on my behalf.
                  </label>
                </div>
              </div>
            </div>
                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                 Your college senior shouts
                                                  at you infront of your class
                                                  mates. You think it is not
                        your fault
                        {"Reslience1"}
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-13"
                    class="radio-custom"
                    name="radio-groupq6"
                    type="radio"
                    defaultValue="High"
                    onClick={(e) => {
                                                            this.setState({
                                                              Resilience1:
                                                                e.target.value,
                                                            })
                      
}                                                          }
                  />
                  <label
                    for="radio-13"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                  I will tell the senior
                                                          not to shout as it is
                                                          not my mistake.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-14"
                    class="radio-custom"
                    name="radio-groupq6"
                    type="radio"
                    defaultValue="Medium"
                    onClick={(e) => {

                                                            this.setState({
                                                              Resilience1:
                                                                e.target.value,
                                                            })
                      
}                                                          }
                  />
                  <label
                    for="radio-14"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                       I will ask him what
                                                          has made him upset.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-15"
                    class="radio-custom"
                    name="radio-groupq6"
                    type="radio"
                      defaultValue="Low"
                    onClick={(e) => {
                                                            this.setState({
                                                              Resilience1:
                                                                e.target.value,
                                                            })
                      
}                                                          }
                  />
                  <label
                    for="radio-15"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                        I will wait for him to
                                                          calm down and will try
                                                          to find out what has
                                                          made him upset.
                  </label>
                </div>
              </div>
            </div>
                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                                  You have not made it to the
                                                  school cricket team even after
                                                  practicing for a year
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-16"
                    class="radio-custom"
                    name="radio-groupq7"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) =>
                    {
                    
                                                            this.setState({
                                                              Resilience2:
                                                                e.target.value,
                                                            })
                    }
                                                          }
                  />
                  <label
                    for="radio-16"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
               I will appear for
                                                          selection trial of my
                                                          local cricket club
                                                          intead.
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-17"
                    class="radio-custom"
                    name="radio-groupq7"
                    type="radio"
                      defaultValue="Medium"
                         onClick={(e) =>
                    {
                                                            this.setState({
                                                              Resilience2:
                                                                e.target.value,
                                                            })
                    }
                                                          }
                  />
                  <label
                    for="radio-17"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                   I will focus on
                                                          studies.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-18"
                    class="radio-custom"
                    name="radio-groupq7"
                    type="radio"
                      defaultValue="Low"
                         onClick={(e) =>
                    {
                    
                                                            this.setState({
                                                              Resilience2:
                                                                e.target.value,
                                                            })
                    }
                                                          }
                  />
                  <label
                    for="radio-18"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                        I will continue
                                                          practicing and
                                                          reappear for selection
                                                          next year.
                  </label>
                </div>
              </div>
            </div>
                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                           The cleanliness level in
                                                  your housing society has gone
                                                  down. You feel that the matter
                                                  should be raised to the
                                                  secretary of the society. He
                                                  has scolded you on previous
                                                  occasions for raising issues
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-19"
                    class="radio-custom"
                    name="radio-groupq8"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) =>{
                  
                      {this.setState({
                                                              Resilience3:
                                                                e.target.value,
                                                            })}
                                                            
}                                                          }
                  />
                  <label
                    for="radio-19"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
            I will meet him to
                                                          discuss the matter
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-20"
                    class="radio-custom"
                    name="radio-groupq8"
                    type="radio"
                      defaultValue="Medium"

                    onClick={(e) =>{
                      {this.setState({
                                                              Resilience3:
                                                                e.target.value,
                                                            })}
                                                            
}                                                          }
                  />
                  <label
                    for="radio-20"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                      I will write a letter
                                                          to him.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-21"
                    class="radio-custom"
                    name="radio-groupq8"
                    type="radio"
                      defaultValue="Low"

                      onClick={(e) =>{
                      {this.setState({
                                                              Resilience3:
                                                                e.target.value,
                                                            })}
                                                            
}                                                          }
                  />
                  <label
                    for="radio-21"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                        I will request my
                                                          neighbour to represent
                                                          the issue.
                  </label>
                </div>
              </div>
            </div>
                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                           The teacher at your coaching
                                                  class has given you a subject
                                                  wise study schedule
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-22"
                    class="radio-custom"
                    name="radio-groupq9"
                    type="radio"
                      defaultValue="High"
                    
                    onClick={(e) => {
                                                            this.setState({
                                                              Personalorganisation1:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-22"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
             I will follow the
                                                          study schedule.
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-23"
                    class="radio-custom"
                    name="radio-groupq9"
                    type="radio"
                      defaultValue="Medium"

                    onClick={(e) => {

                                                            this.setState({
                                                              Personalorganisation1:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-23"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                        I will make some
                                                          modification in the
                                                          study schedule to suit
                                                          my study habits.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-24"
                    class="radio-custom"
                    name="radio-groupq9"
                    type="radio"
                      defaultValue="Low"

                    onClick={(e) => {
                                                            this.setState({
                                                              Personalorganisation1:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-24"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                           I will create my own
                                                          study schedule that
                                                          suits me.
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                              You have to travel to
                                                  another city after 10 days.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-25"
                    class="radio-custom"
                    name="radio-group10"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) => {
                   
                                                            this.setState({
                                                              Personalorganisation2:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-25"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
               I will prepare a
                                                          travel schedule at
                                                         least 3 days in
                                                          advance.
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-26"
                    class="radio-custom"
                    name="radio-groupq10"
                    type="radio"
                      defaultValue="Medium"
                     onClick={(e) => {
        
                                                        this.setState({
                                                              Personalorganisation2:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-26"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                           Since I have travelled
                                                          a lot, a travel
                                                          schedule is not
                            required
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-27"
                    class="radio-custom"
                    name="radio-groupq10"
                    type="radio"
                      defaultValue="Low"
                     onClick={(e) => {
                      
                                                            this.setState({
                                                              Personalorganisation2:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-27"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                         
                            
                                I will finalise my
                                                          travel schedule while
                                                          travelling to the
                                                          city.
                  </label>
                </div>
              </div>
            </div>


            <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                         Before submitting your
                                                  answersheet for the exam
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-28"
                    class="radio-custom"
                    name="radio-groupq11"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) => {
        
                                                            this.setState({
                                                              Personalorganisation3:
                                                                e.target.value,
                                                            })}
                                                          }
                    
                  />
                  <label
                    for="radio-28"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                I will check all the
                                                          answers in detail once
                                                          again.
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-29"
                    class="radio-custom"
                    name="radio-groupq11"
                    type="radio"
                      defaultValue="Medium"
                    onClick={(e) => {
                      
                                                            this.setState({
                                                              Personalorganisation3:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-29"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >    I will glance through
                                                          the answer sheet.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-30"
                    class="radio-custom"
                    name="radio-groupq11"
                    type="radio"
                      defaultValue="Low"
                    onClick={(e) => {

                                                            this.setState({
                                                              Personalorganisation3:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-30"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                               I will not go back to
                                                          the answers as I am
                                                          sure everything would
                                                          be correct.
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                      You are invited for a
                                                  social gathering
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-31"
                    class="radio-custom"
                    name="radio-groupq12"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) => {
                       
                                                            this.setState({
                                                              Sociallyconfident1:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-31"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                I will spend most of
                                                          my time with my
                                                          friends.
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-32"
                    class="radio-custom"
                    name="radio-groupq12"
                    type="radio"
                      defaultValue="Medium"
                    
                    onClick={(e) => {
                       
                                                            this.setState({
                                                              Sociallyconfident1:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-32"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >     I will interact with
                                                          as many new people as
                                                          I can.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-33"
                    class="radio-custom"
                    name="radio-groupq12"
                    type="radio"
                      defaultValue="Low"
                    onClick={(e) => {
                       
                                                            this.setState({
                                                              Sociallyconfident1:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-33"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                            Given the situation
                                                          and my comfort I will
                                                          interact with new
                                                          people.
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                  When I meet a stranger
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-34"
                    class="radio-custom"
                    name="radio-groupq13"
                    type="radio"
                      defaultValue="High"
                     onClick={(e) =>
                     {
                      
                       this.setState({
                                                              Sociallyconfident2:
                                                                e.target.value,
                                                            })}
                                                          }
                    
                  />
                  <label
                    for="radio-34"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
             I take time to know
                                                          the person.
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-35"
                    class="radio-custom"
                    name="radio-groupq13"
                    type="radio"
                      defaultValue="Medium"
                         onClick={(e) =>
                     {
                      
                       this.setState({
                                                              Sociallyconfident2:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-35"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >      I start the
                                                          interaction.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-36"
                    class="radio-custom"
                    name="radio-groupq13"
                    type="radio"
                      defaultValue="Low"
                         onClick={(e) =>
                     {
                      
                       this.setState({
                                                              Sociallyconfident2:
                                                                e.target.value,
                                                            })}
                                                          }
                  />
                  <label
                    for="radio-36"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                         I am open to initiate
                                                          the discussion, but a
                                                          lot depends on the
                                                          other person.
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                                The mobile network tower in
                                                  your locality is not working.
                                                  You and your neighbours are
                                                  getting affected due to the
                                                  network problem.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-37"
                    class="radio-custom"
                    name="radio-groupq14"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) => {
                       
                                                            this.setState({
                                                              Passion1:
                                                                e.target.value,
                                                            })
 }                                                         }
                  />
                  <label
                    for="radio-37"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                I will inform the mobile network company and get it repaired.
               
                  </label>
                </div>
                <div>
                  <input
                    id="radio-38"
                    class="radio-custom"
                    name="radio-groupq14"
                    type="radio"
                      defaultValue="Medium"
                      onClick={(e) => {
                     
                                                            this.setState({
                                                              Passion1:
                                                                e.target.value,
                                                            })
 }                                                         }
                  />
                  <label
                    for="radio-38"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >      I will use the landline.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-39"
                    class="radio-custom"
                    name="radio-groupq14"
                    type="radio"
                      defaultValue="Low"
                      onClick={(e) => {
                       
                                                            this.setState({
                                                              Passion1:
                                                                e.target.value,
                                                            })
 }                                                         }
                  />
                  <label
                    for="radio-39"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                          I will change my mobile network provider.
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                            Till last year only 15
                                                  people participated in the
                                                  blood donation camp.This year
                                                  the principal has asked you to
                                                  guarantee 150 donors ,else he
                                                  will not allow you to conduct
                                                  the camp.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-40"
                    class="radio-custom"
                    name="radio-groupq15"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) => {
                      
                                                            this.setState({
                                                              Passion2:
                                                                e.target.value,
                                                            })
                                              }            }
                  />
                  <label
                    for="radio-40"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                  15 to 150 is a steep
                                                          increase. I will not
                                                          accept the project.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-41"
                    class="radio-custom"
                    name="radio-groupq15"
                    type="radio"
                                                defaultValue="Medium"
                      onClick={(e) => {
                      
                                                            this.setState({
                                                              Passion2:
                                                                e.target.value,
                                                            })
                                              }            }
                  />
                  <label
                    for="radio-41"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >       I will work towards
                                                          ensuring 150 donors.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-42"
                    class="radio-custom"
                    name="radio-groupq15"
                    type="radio"
                      defaultValue="Low"
                      onClick={(e) => {
                     
                                                            this.setState({
                                                              Passion2:
                                                                e.target.value,
                                                            })
                                              }            }
                  />
                  <label
                    for="radio-42"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                                                              I will try to
                                                          negotiate with the
                                                          principal and try to
                                                          bring it down to 50-75
                                                          donors.
                        
                  </label>
                </div>
              </div>
            </div>

              <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                            One of the windows in your
                                                  hostel room is broken
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-43"
                    class="radio-custom"
                    name="radio-groupq16"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) => {
                      
                                                            this.setState({
                                                              Problemsolving1:
                                                                e.target.value,
                                                            })
                      }
                                                          }

                  />
                  <label
                    for="radio-43"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                   I will try to fix it
                                                          myself.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-44"
                    class="radio-custom"
                    name="radio-groupq16"
                    type="radio"
                      defaultValue="Medium"
                     onClick={(e) => {
                    
                                                            this.setState({
                                                              Problemsolving1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-44"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >          I will involve the
                                                          hostel warden and seek
                                                          assistance.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-45"
                    class="radio-custom"
                    name="radio-groupq16"
                    type="radio"
                      defaultValue="Low"
                     onClick={(e) => {
                     
                                                            this.setState({
                                                              Problemsolving1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-45"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                                                            These are common
                                                          problems in a hostel
                                                          and I will manage.
                        
                  </label>
                </div>
              </div>
            </div>
            
                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                           You have scored good marks
                                                  in all subjects except one
                                                  .The final examination is
                                                  approaching in 2 months.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-46"
                    class="radio-custom"
                    name="radio-groupq17"
                    type="radio"
                      defaultValue="High"
                   onClick={(e) => {
                
                                                            this.setState({
                                                              Problemsolving2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-46"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                   I will consult my
                                                          teacher and seek help.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-47"
                    class="radio-custom"
                    name="radio-groupq17"
                    type="radio"
                      defaultValue="Medium"
                      onClick={(e) => {
                  
                                                            this.setState({
                                                              Problemsolving2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-47"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >           I will continue to
                                                          study on my own.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-48"
                    class="radio-custom"
                    name="radio-groupq17"
                    type="radio"
                      defaultValue="Low"
                      onClick={(e) => {
                      
                                                            this.setState({
                                                              Problemsolving2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-48"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                                                           I will change my
                                                          elective.
                        
                  </label>
                </div>
              </div>
            </div>



                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                         You are waiting for a
                                                  friend at his college gate. He
                                                  is going to be late by 15
                                                  minutes
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-49"
                    class="radio-custom"
                    name="radio-groupq18"
                    type="radio"
                      defaultValue="High"
                      onClick={(e) => {
                      
                                                            this.setState({
                                                              Affiliation1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-49"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                     I will engage with the
                                                          security guard of the
                                                          college and see if I
                                                          can find common
                                                          interests to pass
                                                          time.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-50"
                    class="radio-custom"
                    name="radio-groupq18"
                    type="radio"
                      defaultValue="Medium"
                       onClick={(e) => {
                      
                                                            this.setState({
                                                              Affiliation1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-50"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >          I will go to the
                                                          nearby shop.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-51"
                    class="radio-custom"
                    name="radio-groupq18"
                    type="radio"
                      defaultValue="Low"
                       onClick={(e) => {
                     
                                                            this.setState({
                                                              Affiliation1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-51"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                          I will try and find
                                                          someone I know in that
                                                          college till my friend
                                                          comes.
                        
                  </label>
                </div>
              </div>
            </div>
                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                       
                                       You have gone to you
                                                  friend's house for the first
                                                  time.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-52"
                    class="radio-custom"
                    name="radio-groupq19"
                    type="radio"
                      defaultValue="High"
                       onClick={(e) => {
                     
                                                            this.setState({
                                                              Affiliation2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-52"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                       I will interact with
                                                          my friend's family
                                                          members and share
                                                          information about
                                                          myself and my family.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-53"
                    class="radio-custom"
                    name="radio-groupq19"
                    type="radio"
                      defaultValue="Medium"
                        onClick={(e) => {
                   
                                                            this.setState({
                                                              Affiliation2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-53"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >            If my friend's family
                                                          members talk to me , I
                                                          will share information
                                                          about myself.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-54"
                    class="radio-custom"
                    name="radio-groupq19"
                    type="radio"
                      defaultValue="Low"
                        onClick={(e) => {
                      
                                                            this.setState({
                                                              Affiliation2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-54"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                         I will greet the
                                                          family members and go
                                                          to my friend's room.
                        
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                       
                                    You meet one of your
                                                  college professors in a
                                                  shopping mall after 4 years.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-55"
                    class="radio-custom"
                    name="radio-groupq20"
                    type="radio"
                      defaultValue="High"
                        onClick={(e) => {
                     
                                                            this.setState({
                                                              Affiliation3:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-55"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    You greet him and
                                                          spend some time with
                                                          him.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-56"
                    class="radio-custom"
                    name="radio-groupq20"
                    type="radio"
                      defaultValue="Medium"
                     onClick={(e) => {
                   
                                                            this.setState({
                                                              Affiliation3:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-56"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >        You greet him and
                                                          continue with your
                                                          shopping.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-57"
                    class="radio-custom"
                    name="radio-groupq20"
                    type="radio"
                      defaultValue="Low"
                     onClick={(e) => {
                     
                                                            this.setState({
                                                              Affiliation3:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-57"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                          You let him pass as
                                                          its been a long time
                                                          since college ended.
                        
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                       You and your friends have
                                                  to catch a train and the train
                                                  tickets are with you.While
                                                  leaving for the station you
                                                  notice that your aged
                                                  neighbour is struggling to
                                                  unlock his house door.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-58"
                    class="radio-custom"
                    name="radio-groupq21"
                    type="radio"
                      defaultValue="High"
                    onClick={(e) => {
                      
                                                            this.setState({
                                                              Affiliation4:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-58"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                     I will assist him in
                                                          unlocking the door.
                  </label>
                </div>
                <div>
                  <input
                    id="radio-59"
                    class="radio-custom"
                    name="radio-groupq21"
                    type="radio"
                      defaultValue="Medium"
                       onClick={(e) => {
                      
                                                            this.setState({
                                                              Affiliation4:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-59"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >    I will rush to the
                                                          station as all the
                                                          tickets are with me.
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-60"
                    class="radio-custom"
                    name="radio-groupq21"
                    type="radio"
                      defaultValue="Low"
                       onClick={(e) => {
                     
                                                            this.setState({
                                                              Affiliation4:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-60"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                          I will ask the
                                                          security guard of the
                                                          society to help my
                                                          neighbour.
                        
                  </label>
                </div>
              </div>
            </div>

                        <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                                   You phone your friend to go
                                                  for a movie. Your friend
                                                  sounds disturbed
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-61"
                    class="radio-custom"
                    name="radio-groupq22"
                    type="radio"
                      defaultValue="High"
                      onClick={(e) => {
                      
                                                            this.setState({
                                                              ServiceRecovery1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-61"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                    You will call another
                                                          friend and check with
                                                          him
                  </label>
                </div>
                <div>
                  <input
                    id="radio-62"
                    class="radio-custom"
                    name="radio-groupq22"
                    type="radio"
                      defaultValue="Medium"
                       onClick={(e) => {
                      
                                                            this.setState({
                                                              ServiceRecovery1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-62"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >          You will meet him to
                                                          understand his problem
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-63"
                    class="radio-custom"
                    name="radio-groupq22"
                    type="radio"
                     defaultValue="Low"
                        onClick={(e) => {
                      
                                                            this.setState({
                                                              ServiceRecovery1:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-63"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                            You will talk to him
                                                          of his problem after
                                                          watching the movie
                        
                  </label>
                </div>
              </div>
            </div>


            <div className="mb-6 ">
              <ul>
                <li className="text-black fsize16 list-decimal line-h30  sm-fsize14  lg:ml-0 md:ml-0 ml-4">
                               A family of three comes to
                                                  your food stall in your
                                                  college fest. They keep
                                                  changing their mind about the
                                                  order quantity and spread.
                </li>
              </ul>
              <div className="mt-2">
                <div>
                  <input
                    id="radio-64"
                    class="radio-custom"
                    name="radio-groupq23"
                    type="radio"
                      defaultValue="High"
                        onClick={(e) => {
                      
                                                            this.setState({
                                                              ServiceRecovery2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-64"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                         You advise them on the
                                                          dishes to be ordered
                  </label>
                </div>
                <div>
                  <input
                    id="radio-65"
                    class="radio-custom"
                    name="radio-groupq23"
                    type="radio"
                      defaultValue="Medium"
                            onClick={(e) => {
                      
                                                            this.setState({
                                                              ServiceRecovery2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-65"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >          You will wait till
                                                          they make up their
                                                          mind
                  </label>
                </div>{" "}
                <div>
                  <input
                    id="radio-66"
                    class="radio-custom"
                    name="radio-groupq23"
                    type="radio"
                      defaultValue="Low"
                            onClick={(e) => {
                    
                                                            this.setState({
                                                              ServiceRecovery2:
                                                                e.target.value,
                                                            })
                      }
                                                          }
                  />
                  <label
                    for="radio-66"
                    class="radio-custom-label fsize16 text-black font-normal sm-fsize14"
                  >
                         You will politely ask
                                                          them to wait to
                                                          service others in the
                                                          queue
                        
                  </label>
                </div>
              </div>
            </div>



       
            
            
          </div>
          {/* <div class="w-full  flex justify-end f-full mt-16">
            <button type="submit"
              onClick={(e) => this.saveProfiler(e)}
              className="filled-button profiler-btn-w h-47px sm-fsize14 fsize16 font-semibold rounded-25px">
              SUBMIT
            </button>
          </div> */}
           <div
                                  className="w-full  flex justify-end f-full mt-16"
                                  className={
                                    this.isKycCompletedCheck()
                                      ? "accept-btn p-8 md:ml-4"
                                      : "accept-btn-disabled p-8 md:ml-4"
                                  }
                                >
                                  <button
                                    type="submit"
                                    disabled={
                                      !this.isKycCompletedCheck()
                                        ? "disabled"
                                        : ""
                                    }
                                    onClick={(e) => this.saveProfiler(e)}
                              
                                   
                                  id="ctl00_ContentPlaceHolder1_btnSave"
                                    className="filled-button profiler-btn-w h-47px sm-fsize14 fsize16 font-semibold rounded-25px"
                                   
                                  >SUBMIT</button>
                                </div> 
        </div>
      </card>
    );
  }
}
const mapStateToProps = (state) => {
  
  return {
    Auth: state.Auth.user,
    
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    postProfileDataSaveAction: async (payload) => {
      await dispatch(postProfileDataSaveAction(payload));
    },
    
    
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Profiler);

